import React from 'react';
import {
  Table,
  Spinner,
  Button,
  OverlayTrigger,
  Tooltip,
  Pagination,
  Row,
  Col,
  Card,
  CardDeck
} from 'react-bootstrap';
import _ from 'lodash';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faQuestionCircle,
  faEllipsisV,
  faSyncAlt
} from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis
} from 'recharts';
import Abstentions from './Abstentions';
import Obs from './Obs';
import ListHighTurnover from './ListHighTurnover';
import ExportPulses from './ExportPulses';
import FiterAPI from '../fiterAPI';
import UserHistoryModal from './Modal/UserHistoryModal';
import FiterCheckbox from './FiterCheckbox';

const searchableFields = [
  {
    keyName: 'nameCandidate',
    label: 'Candidato'
  },
  {
    keyName: 'course',
    label: 'Curso'
  }
];
const monthsName = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

const ITENS_PER_PAGE = 100;

function formatDashboard(value) {
  return (
    (value < 10 && 'pd text-center') ||
    (value <= 15 && 'neutro text-center') ||
    'forca text-center'
  );
}
function numberToState(value) {
  return (value < 10 && 'PD') || (value <= 15 && 'Neutro') || 'Força';
}
class DashboardPulse extends React.Component {
  constructor() {
    super();

    this.state = {
      data: [],
      allPulses: [],
      count: 0,
      page: 1,
      pages: 1,
      sortedAnswers: [],
      searchKey: '',
      searchValue: '',
      classesFilter: [],
      areasFilter: [],
      loaded: false,
      monthsList: [],
      monthFilter: [],
      abstentions: [],
      abstentionsCount: 0,
      monthFilterIndex: 0,
      fixedPulses: [],
      fixedMonthFilterIndex: 0,
      respondents: 0,
      limit: ITENS_PER_PAGE,
      usersFilter: [],
      refreshCount: 0,
      showUserHistory: false,
      userToShow: '',
      turnoverFilter: false,
      commentsFilter: false
    };

    this.getPulses = this.getPulses.bind(this);
    this.getLabelMedia = this.getLabelMedia.bind(this);
    this.setCurrentPage = this.setCurrentPage.bind(this);
    this.courses = [];
    this.getAbstentions = this.getAbstentions.bind(this);
  }

  async componentDidMount() {
    await this.getPulses(this.state);
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const _pulses = await FiterAPI.getAllPulsesByMonth({});
    const { courses = [], getUsersList, getUnits } = this.props;
    const unitsList = (await getUnits()) || [];
    const unitListFilter = unitsList.map(unit => ({
      value: unit.id,
      label: unit.name
    }));
    // this.setState({ usersListFilter: usersList.map(user => ({ value: user.id, label: user.name })) })
    await this.setState({ unitListFilter });

    this.courses = _.sortBy(
      _.map(courses, ({ id, name }) => ({
        label: name,
        value: id
      })),
      'label'
    );
    await this.setState({
      allPulses: _.get(await this.props.getPulses(this.state), 'data'),
      pulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: `${monthsName[monthIndex]}/${_pulse.year}`
        })),
        []
      ),
      fixedPulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: `${monthsName[monthIndex]}/${_pulse.year}`
        })),
        []
      ),
      monthsList: _.concat(
        _.map(_pulses, ({ monthIndex, index, ..._pulse }) => ({
          label: `${monthsName[monthIndex]}/${_pulse.year}`,
          value: `${_pulse.year}-${monthIndex + 1}-03`,
          index,
          filterKey: `${_pulse.year}-${monthIndex + 1}`
        })),
        _pulses[_pulses.length - 1].monthIndex !== currentMonth ||
          _pulses[_pulses.length - 1].year !== currentYear
          ? [
            {
              label: `${monthsName[currentMonth]}/${currentYear}`,
              value: `${currentYear}-${currentMonth + 1}-03`,
              index: _pulses.length
            }
          ]
          : [],
        []
      )
    });
    const areasList = await FiterAPI.getAreas({});

    this.areas = _.sortBy(
      _.map(areasList, ({ id, label }) => ({
        label,
        value: id
      })),
      'label'
    );

    try {
      await this.setState({
        monthFilterIndex: this.state.pulses.length - 1,
        fixedMonthFilterIndex: this.state.pulses.length - 1
      });
    } catch (err) {
      console.log(err);
    }
    // await this.getAbstentions()
  }

  async setCurrentPage(page) {
    this.setState({ page, data: [] });
    this.getPulses(this.state);
  }

  // TODO: Mostrar o consolidado de todas as páginas para o filtro atual
  async getPulses() {
    this.setState({ loaded: false });
    const {
      data,
      count,
      evasionMedia,
      evasionData
    } = await this.props.getPulses(this.state);
    const pages = Math.ceil(count / ITENS_PER_PAGE);
    this.setState({
      data,
      count,
      pages,
      respondents: count,
      evasionMedia,
      evasionData
    });
    this.setState({ loaded: true });
  }

  getSearchByLabel() {
    const { searchKey } = this.state;
    return _.get(
      _.filter(searchableFields, field => field.keyName === searchKey),
      '[0].label',
      'Selecione o campo'
    );
  }

  async getAbstentions() {
    await this.setState({
      abstentions: await this.props.getAbstentions(this.state)
    });
  }

  setsearchKey(searchKey) {
    this.setState({ searchKey });
  }

  setsearchValue(searchValue) {
    this.setState({ searchValue });
  }

  getLabelMedia() {
    const { allPulses } = this.state;
    const total = _.get(allPulses, 'length', 0);
    const { length } = _.filter(
      allPulses,
      ({ evasionLabel }) => evasionLabel === 'Medio Alto'
    );

    return total ? Math.round((length / total + Number.EPSILON) * 100) : 0;
  }

  getAverageProperty(total, key) {
    const { allPulses = [] } = this.state;
    const { length } = _.filter(allPulses, answer =>
      Object.prototype.hasOwnProperty.call(answer, key)
    );
    return length
      ? Math.round((total / length + Number.EPSILON) * 100) / 100
      : 0;
  }

  handleUsersChange = async usersFilter => {
    if (usersFilter === null) usersFilter = [];
    const {
      monthFilter,
      fixedPulses = [],
      areasFilter,
      unitFilter
    } = this.state;
    this.setState({
      usersFilter,
      areasFilter: [],
      data: [],
      allPulses: [],
      loaded: false,
      page: 1
    });
    const _pulses = await FiterAPI.getAllPulsesByMonth({
      areasFilter,
      unitFilter
    });
    let monthFilterIndex = '';
    let fixedMonthFilterIndex = '';
    _pulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        monthFilterIndex = pulse.index;
    });
    fixedPulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        fixedMonthFilterIndex = pulse.index;
    });
    await this.setState({
      allPulses: _.get(
        await this.props.getPulses({
          limit: ITENS_PER_PAGE,
          usersFilter,
          monthFilter
        }),
        'data'
      ),
      pulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: `${monthsName[monthIndex]}/${_pulse.year}`
        })),
        []
      ),
      monthFilterIndex:
        monthFilterIndex >= 0 && monthFilterIndex !== ''
          ? monthFilterIndex
          : _pulses.length - 1,
      fixedMonthFilterIndex:
        fixedMonthFilterIndex >= 0 && fixedMonthFilterIndex !== ''
          ? fixedMonthFilterIndex
          : fixedPulses.length - 1
    });

    this.getPulses(this.state);
  };

  handleUnitChange = async unitFilter => {
    if (unitFilter === null) unitFilter = [];
    this.setState({ loaded: false });
    const { monthFilter, areasFilter, fixedPulses = [] } = this.state;
    this.setState({
      unitFilter,
      usersFilter: [],
      areasFilter: [],
      data: [],
      allPulses: [],
      loaded: false,
      page: 1
    });

    const areasList = await FiterAPI.getAreas({ unitFilter });

    this.areas = _.sortBy(
      _.map(areasList, ({ id, label }) => ({
        label,
        value: id
      })),
      'label'
    );
    const _pulses = await FiterAPI.getAllPulsesByMonth({
      areasFilter,
      unitFilter
    });
    let monthFilterIndex = '';
    let fixedMonthFilterIndex = '';
    _pulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        monthFilterIndex = pulse.index;
    });
    fixedPulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        fixedMonthFilterIndex = pulse.index;
    });
    await this.setState({
      allPulses: _.get(
        await this.props.getPulses({
          limit: ITENS_PER_PAGE,
          unitFilter,
          monthFilter,
          commentsFilter: this.state.commentsFilter,
          turnoverFilter: this.state.turnoverFilter
        }),
        'data'
      ),
      pulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: `${monthsName[monthIndex]}/${_pulse.year}`
        })),
        []
      ),
      monthFilterIndex:
        monthFilterIndex >= 0 && monthFilterIndex !== ''
          ? monthFilterIndex
          : _pulses.length - 1,
      fixedMonthFilterIndex:
        fixedMonthFilterIndex >= 0 && fixedMonthFilterIndex !== ''
          ? fixedMonthFilterIndex
          : fixedPulses.length - 1
    });

    this.getPulses(this.state);
    // this.getAbstentions()
  };

  handleAreasChange = async areasFilter => {
    if (areasFilter === null) areasFilter = [];
    this.setState({ loaded: false });
    const { monthFilter, fixedPulses = [], unitFilter } = this.state;
    this.setState({
      areasFilter,
      usersFilter: [],
      data: [],
      allPulses: [],
      loaded: false,
      page: 1
    });
    const _pulses = await FiterAPI.getAllPulsesByMonth({
      areasFilter,
      unitFilter
    });
    let monthFilterIndex = '';
    let fixedMonthFilterIndex = '';
    _pulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        monthFilterIndex = pulse.index;
    });
    fixedPulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        fixedMonthFilterIndex = pulse.index;
    });
    await this.setState({
      allPulses: _.get(
        await this.props.getPulses({
          limit: ITENS_PER_PAGE,
          areasFilter,
          monthFilter
        }),
        'data'
      ),
      pulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: `${monthsName[monthIndex]}/${_pulse.year}`
        })),
        []
      ),
      monthFilterIndex:
        monthFilterIndex >= 0 && monthFilterIndex !== ''
          ? monthFilterIndex
          : _pulses.length - 1,
      fixedMonthFilterIndex:
        fixedMonthFilterIndex >= 0 && fixedMonthFilterIndex !== ''
          ? fixedMonthFilterIndex
          : fixedPulses.length - 1
    });
    this.getPulses(this.state);
    // this.getAbstentions()
  };

  handleMonthChange = async monthFilter => {
    const { areasFilter, fixedPulses = [], unitFilter } = this.state;
    this.setState({ loaded: false });
    const _pulses = await FiterAPI.getAllPulsesByMonth({
      areasFilter,
      unitFilter
    });
    let monthFilterIndex = '';
    let fixedMonthFilterIndex = '';
    _pulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        monthFilterIndex = pulse.index;
    });
    fixedPulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        fixedMonthFilterIndex = pulse.index;
    });

    await this.setState({ monthFilter, data: [], allPulses: [], page: 1 });
    await this.setState({
      allPulses: _.get(
        await this.props.getPulses({
          limit: ITENS_PER_PAGE,
          monthFilter,
          areasFilter
        }),
        'data'
      ),
      pulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: `${monthsName[monthIndex]}/${_pulse.year}`
        })),
        []
      ),
      monthFilterIndex,
      fixedMonthFilterIndex
    });
    this.getPulses(this.state);
    // this.getAbstentions()
  };

  handleRefresh = async () => {
    this.setState({ loaded: false });
    this.setState({ refreshCount: prev => prev.refreshCount + 1 });

    const {
      monthFilter,
      fixedPulses = [],
      unitFilter,
      areasFilter
    } = this.state;
    await this.setState({ usersFilter: [] });
    const _pulses = await FiterAPI.getAllPulsesByMonth({
      areasFilter,
      unitFilter
    });
    let monthFilterIndex = '';
    let fixedMonthFilterIndex = '';
    _pulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        monthFilterIndex = pulse.index;
    });
    fixedPulses.map(pulse => {
      if (pulse.filterKey === monthFilter.filterKey)
        fixedMonthFilterIndex = pulse.index;
    });
    this.setState({
      areasFilter,
      data: [],
      allPulses: [],
      loaded: false,
      page: 1
    });
    await this.setState({
      allPulses: _.get(
        await this.props.getPulses({
          limit: ITENS_PER_PAGE,
          areasFilter,
          monthFilter,
          onlyWithComments: this.state.commentsFilter,
          onlyWithTurnover: this.state.turnoverFilter
        }),
        'data'
      ),
      pulses: _.concat(
        _.map(_pulses, ({ monthIndex, ..._pulse }) => ({
          ..._pulse,
          name: `${monthsName[monthIndex]}/${_pulse.year}`
        })),
        []
      ),
      monthFilterIndex:
        monthFilterIndex >= 0 && monthFilterIndex !== ''
          ? monthFilterIndex
          : _pulses.length - 1,
      fixedMonthFilterIndex:
        fixedMonthFilterIndex >= 0 && fixedMonthFilterIndex !== ''
          ? fixedMonthFilterIndex
          : fixedPulses.length - 1
    });
    this.getPulses(this.state);
    // this.getAbstentions()
  };

  handleFirstName = () => {
    this.state.compactNameList
      ? this.setState({ compactNameList: false })
      : this.setState({ compactNameList: true });
  };

  handleSetAbstentionsCount = count => {
    this.setState({ abstentionsCount: count });
  };

  handleHideUserHistory = () => {
    this.setState({
      showUserHistory: false
    });
  };

  handleShowUserHistory = userId => {
    this.setState({
      showUserHistory: true,
      userToShow: userId
    });
  };

  async sortBy(sortKey) {
    this.setState(prevState => ({
      sortKey,
      sortDirection:
        prevState.sortDirection !== 'ascending' ? 'ascending' : 'descending'
    }));
    this.getPulses();
  }

  reduceProperty(key) {
    const { allPulses } = this.state;
    return (
      (allPulses.length &&
        allPulses.reduce(
          (acc, currentValue) => acc + _.get(currentValue, key, 0),
          0
        )) ||
      0
    );
  }

  handleTurnoverFilter = filter => {
    this.setState({ turnoverFilter: filter });
    this.handleRefresh();
  };

  handleCommentsFilter = filter => {
    this.setState({ commentsFilter: filter });
    this.handleRefresh();
  };

  render() {
    const {
      data,
      pages,
      page,
      allPulses,
      classesFilter,
      areasFilter,
      unitFilter,
      loaded,
      pulses,
      fixedPulses,
      monthsList,
      monthFilter,
      abstentions,
      monthFilterIndex,
      fixedMonthFilterIndex,
      compactNameList,
      respondents,
      usersListFilter,
      usersFilter,
      evasionMedia,
      evasionData,
      unitListFilter,
      abstentionsCount,
      commentsFilter,
      turnoverFilter
    } = this.state;

    const currentPulseData = pulses ? pulses[monthFilterIndex] : {};
    const happinessMedia = currentPulseData?.happiness;

    const archetypeMedia = currentPulseData?.archetype;

    const healthScoreTotal = this.reduceProperty('health');
    const healthScoreMedia = this.getAverageProperty(
      healthScoreTotal,
      'health'
    );

    const evasionLabelMedia = this.getLabelMedia();
    const { roleName } = this.props.currentUser;
    const currentUserId = this.props.currentUser.id;
    const currentAvatar = this.props.currentInstitution.avatar[roleName]
      ? this.props.currentInstitution.avatar[roleName]
      : this.props.currentInstitution.avatar;
    // const abstentions = this.props.getAbstentions
    const { usersList } = this.props;

    function getRespondentsPercentage() {
      if (respondents) {
        return loaded
          ? Number(
            (respondents / (abstentionsCount + respondents)) * 100
          ).toFixed(1)
          : '...';
      }
      return '...';
    }
    const getUsersList = AwesomeDebouncePromise(async searchValue => {
      const _usersList = await this.props.getUsersList({
        limit: 50,
        searchValue
      });
      const _formatedUsersList = _usersList.map(user => ({
        label: user.name,
        value: user.id
      }));
      return _formatedUsersList;
    }, 600);
    let radarDataValues = [];
    let radarDataValues2 = [];

    function getRadarData(type) {
      const getFactor = index => (index % 2 === 0 ? 30 : 20);
      const start = type === 'happiness' ? 0 : 4;
      const teste = [];
      for (let j = start; j < start + 4; j++) {
        teste.push({
          subject: currentAvatar.archetype[j],
          A: Math.round(
            (pulses[monthFilterIndex].answers[`question-${j}`] / getFactor(j)) *
            100
          ),
          B: Math.round(
            (fixedPulses[fixedMonthFilterIndex].answers[`question-${j}`] /
              getFactor(j)) *
            100
          ),
          fullMark: 100
        });
      }
      return teste;
    }
    try {
      radarDataValues = getRadarData('happiness');
      radarDataValues2 = getRadarData('archetype');
    } catch {
      radarDataValues = [];
      radarDataValues2 = [];
    }

    return (
      <>
        <UserHistoryModal
          setShow={this.handleHideUserHistory}
          show={this.state.showUserHistory}
          userId={this.state.userToShow}
        />
        <Row md="12">
          <Col
            className="mt-3 col-md-4"
            style={{
              minWidth: '150px',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <AsyncSelect
              // value={usersFilter}
              loadOptions={getUsersList}
              // options={usersListFilter}
              className="select-filter"
              placeholder="Filtro de usuário"
              isMulti
              onChange={this.handleUsersChange}
            />
            <FiterCheckbox
              label="Mostrar apenas com risco de evasão"
              checked={turnoverFilter}
              setChecked={this.handleTurnoverFilter}
            />
            <FiterCheckbox
              label="Mostrar apenas com comentarios"
              checked={commentsFilter}
              setChecked={this.handleCommentsFilter}
            />

            {/* <Select
              value={usersFilter}
              onChange={this.handleUsersChange}
              options={usersListFilter}
              isMulti={true}
              className="select-filter"
              placeholder={`Filtro de usuário`}
            /> */}
          </Col>
          <Col className="mt-3 col-md-3 " style={{ minWidth: '150px' }}>
            <Select
              value={unitFilter}
              onChange={this.handleUnitChange}
              options={unitListFilter}
              isMulti
              className="select-filter"
              placeholder="Filtros de unidade"
            />
          </Col>
          <Col className="mt-3 col-md-3 " style={{ minWidth: '150px' }}>
            <Select
              value={areasFilter}
              onChange={this.handleAreasChange}
              options={this.areas}
              isMulti
              className="select-filter"
              placeholder={`Filtros de ${currentAvatar.filter}`}
              isDisabled={this.areas ? this.areas.length === 0 : false}
            />
          </Col>
          <Col className="mt-3 col-md-2" style={{ minWidth: '150px' }}>
            <Select
              value={monthFilter}
              onChange={this.handleMonthChange}
              options={monthsList}
              className="select-filter"
              placeholder="Filtro de mês"
            />
          </Col>
        </Row>

        <Table responsive bordered className="fixed-columns tableFixHead">
          <thead>
            <tr>
              <th className="empty-cell" colSpan={1}>
                <Button
                  variant="secondary"
                  onClick={() => this.handleRefresh()}
                  disabled={!loaded}
                >
                  {loaded ? (
                    <>
                      <FontAwesomeIcon icon={faSyncAlt} />
                    </>
                  ) : (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </>
                  )}
                </Button>
              </th>
              <th className="empty-cell name-header" colSpan={2} />
              <th className="header-group" colSpan={5}>
                {currentAvatar.happinessText || 'Taxa de felicidade'}
              </th>
              <th className="header-group" colSpan={5}>
                Taxa de {currentAvatar.pulse}
              </th>
              <th className="header-group" colSpan={2}>
                Health Score
              </th>
            </tr>
            <tr>
              <th
                role="text"
                className="name-header"
                onClick={this.handleFirstName}
              >
                Nome{' '}
                {/* // <FontAwesomeIcon
                //   icon={faSort}
                //   onClick={() => this.sortBy('nameCandidate')}
                // /> */}
              </th>
              <th>
                {currentAvatar.groupName}{' '}
                {/* // <FontAwesomeIcon
                //   icon={faSort}
                //   onClick={() => this.sortBy('nameInterviewer')}
                // /> */}
              </th>
              <th> Unidade </th>
              <th>
                Data{' '}
                <FontAwesomeIcon
                  icon={faSort}
                  onClick={() => this.sortBy('createdAt')}
                />
              </th>

              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[0]}
              </th>
              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[1]}
              </th>
              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[2]}
              </th>
              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[3]}
              </th>
              <th>Resultado</th>
              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[4]}
              </th>
              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[5]}
              </th>
              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[6]}
              </th>
              <th className="archetypes-headers text-center">
                {currentAvatar.archetype[7]}
              </th>
              <th>Resultado</th>
              <th>Taxa de saúde</th>
              <th>{currentAvatar.healthScore}</th>
            </tr>
          </thead>
          {!loaded ? (
            <div className="table-spinner d-flex justify-content-center">
              <div className="spinner-border" />
            </div>
          ) : (
            <tbody>
              {_.map(data, (answer, index) => (
                <tr key={index}>
                  <td>
                    <div style={{ display: 'flex' }}>
                      <span>
                        <Obs
                          icon={faEllipsisV}
                          color="grey"
                          pulseId={answer.pulseId}
                          authorId={answer.authorId}
                          comments={answer.obs}
                          currentUserId={currentUserId}
                          usersList={usersList}
                          firstDropdownValueProps={answer.firstDropdownValue}
                          secondDropdownValueProps={answer.secondDropdownValue}
                          currentInstitution={this.props.currentInstitution}
                        />
                      </span>
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          this.handleShowUserHistory(answer.objectId)
                        }
                      >
                        {compactNameList
                          ? String(answer.name).slice(
                            0,
                            String(answer.name).indexOf(' ')
                          )
                          : answer.name}
                      </div>
                    </div>
                  </td>
                  <td>{answer.courseName}</td>
                  <td>{answer.unitName}</td>
                  <td>{answer.date}</td>
                  <td className={formatDashboard(answer.answers['question-0'])}>
                    {numberToState(answer.answers['question-0'])}
                  </td>
                  <td className={formatDashboard(answer.answers['question-1'])}>
                    {numberToState(answer.answers['question-1'])}
                  </td>
                  <td className={formatDashboard(answer.answers['question-2'])}>
                    {numberToState(answer.answers['question-2'])}
                  </td>
                  <td className={formatDashboard(answer.answers['question-3'])}>
                    {numberToState(answer.answers['question-3'])}
                  </td>
                  <td className={(answer.happiness < 70 && 'reprovado') || ''}>
                    {answer.happiness}
                  </td>
                  <td className={formatDashboard(answer.answers['question-4'])}>
                    {numberToState(answer.answers['question-4'])}
                  </td>
                  <td className={formatDashboard(answer.answers['question-5'])}>
                    {numberToState(answer.answers['question-5'])}
                  </td>
                  <td className={formatDashboard(answer.answers['question-6'])}>
                    {numberToState(answer.answers['question-6'])}
                  </td>
                  <td className={formatDashboard(answer.answers['question-7'])}>
                    {numberToState(answer.answers['question-7'])}
                  </td>
                  <td
                    className={
                      (answer.archetype < 70 && 'reprovado text-center') ||
                      'text-center'
                    }
                  >
                    {answer.archetype}
                  </td>
                  <td
                    className={
                      (answer.health < 70 && 'reprovado text-center') ||
                      'text-center'
                    }
                  >
                    {answer.health}
                  </td>
                  <td
                    className={
                      (answer.evasion < 70 && 'reprovado text-center') ||
                      'text-center'
                    }
                  >
                    <>
                      {answer.evasionLabel}
                      {answer.comments ? (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip>{answer.comments}</Tooltip>}
                          popperConfig={{
                            modifiers: {
                              preventOverflow: {
                                enabled: false
                              }
                            }
                          }}
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={faQuestionCircle}
                              className="ml-2"
                            />
                          </span>
                        </OverlayTrigger>
                      ) : (
                        <></>
                      )}{' '}
                    </>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </Table>
        <Pagination>
          {pages > 1 ? (
            <Pagination.Prev
              disabled={page === 1}
              onClick={() => this.setCurrentPage(page - 1)}
            />
          ) : (
            <></>
          )}
          <Pagination.Item
            active={page === 1}
            onClick={() => this.setCurrentPage(1)}
          >
            1
          </Pagination.Item>

          {pages > 2 && page !== 1 && page !== pages ? (
            <>
              {page !== 1 ? <Pagination.Ellipsis disabled /> : <></>}
              <Pagination.Item active>{page}</Pagination.Item>
              {page !== pages - 2 ? <Pagination.Ellipsis disabled /> : <></>}
            </>
          ) : (
            <Pagination.Ellipsis disabled />
          )}

          {pages > 1 ? (
            <>
              <Pagination.Item
                active={page === pages}
                onClick={() => this.setCurrentPage(pages)}
              >
                {pages}
              </Pagination.Item>
              <Pagination.Next
                disabled={page === pages}
                onClick={() => this.setCurrentPage(page + 1)}
              />
            </>
          ) : (
            <></>
          )}
        </Pagination>
        <br />
        <Row>
          <Col>
            <Abstentions
              setAbstentionsCount={this.handleSetAbstentionsCount}
              refreshCount={this.state.refreshCount}
              monthFilter={monthFilter}
              areasFilter={areasFilter}
              unitFilter={unitFilter}
              getAbstentions={this.props.getAbstentions}
              abstentions={abstentions}
            />
          </Col>

          <Col>
            <ExportPulses
              data={data}
              avatar={currentAvatar}
              courses={this.courses}
              monthFilter={monthFilter}
              currentInstitution={this.props.currentInstitution}
            />
          </Col>
        </Row>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>
                {' '}
                Taxa de respondentes {getRespondentsPercentage()}% |{' '}
                {respondents} Participantes{' '}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{currentAvatar.happinessText || 'Taxa de felicidade'}</td>
              <td className={(happinessMedia < 70 && 'reprovado') || ''}>
                {happinessMedia || 0}%
              </td>
            </tr>
            <tr>
              <td>Taxa de {currentAvatar.pulse}</td>
              <td className={(archetypeMedia < 70 && 'reprovado') || ''}>
                {archetypeMedia || 0}%
              </td>
            </tr>
            <tr>
              <td>Taxa de Health Score</td>
              <td className={(healthScoreMedia < 70 && 'reprovado') || ''}>
                {healthScoreMedia || 0}%
              </td>
            </tr>
            <tr>
              <td>Taxa de {currentAvatar.healthScore} Médio Alto</td>
              <td className={(evasionMedia >= 30 && 'reprovado') || ''}>
                <ListHighTurnover evasion={evasionMedia} data={evasionData} />
              </td>
            </tr>
          </tbody>
        </Table>

        <CardDeck className="mt-3 mb-3">
          <Card>
            <Card.Header>Linha do tempo da Felicidade</Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <LineChart
                    width={500}
                    height={300}
                    data={pulses}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5
                    }}
                  >
                    <CartesianGrid strokeDasharray="6 6" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <RechartsTooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      name={currentAvatar.happinessText || 'Taxa de felicidade'}
                      dataKey="happiness"
                      stroke="#82ca9d"
                      activeDot={{ r: 8 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>Linha do tempo de {currentAvatar.pulse}</Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <LineChart
                    width={500}
                    height={300}
                    data={pulses}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5
                    }}
                  >
                    <CartesianGrid strokeDasharray="6 6" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <RechartsTooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="archetype"
                      name={`Taxa de ${currentAvatar.pulse}`}
                      stroke="#8884d8"
                      activeDot={{ r: 8 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </CardDeck>
        <CardDeck className="mt-3 mb-3">
          <Card>
            <Card.Header>
              Radar da Felicidade - {monthFilter.label || 'atual'}
            </Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <RadarChart
                    outerRadius={130}
                    width={300}
                    height={300}
                    data={radarDataValues}
                  >
                    <PolarGrid domain={[0, 100]} />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis />
                    <RechartsTooltip />
                    <Radar
                      name=""
                      dataKey="A"
                      stroke="#82ca9d"
                      fill="#82ca9d"
                      fillOpacity={0.6}
                    />
                    <Radar
                      name=""
                      dataKey="B"
                      stroke="#FFA500"
                      fill="#FFA500"
                      fillOpacity={0}
                    />
                  </RadarChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>
              Radar de {currentAvatar.pulse} - {monthFilter.label || 'atual'}
            </Card.Header>
            <Card.Body>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                  <RadarChart
                    outerRadius={130}
                    width={300}
                    height={300}
                    data={radarDataValues2}
                  >
                    <PolarGrid domain={[0, 100]} />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis />
                    <RechartsTooltip />

                    <Radar
                      name=""
                      dataKey="A"
                      stroke="#8884d8"
                      fill="#8884d8"
                      fillOpacity={0.6}
                    />
                    <Radar
                      name=""
                      dataKey="B"
                      stroke="#FFA500"
                      fill="#FFA500"
                      fillOpacity={0}
                    />
                  </RadarChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </CardDeck>
      </>
    );
  }
}

export default DashboardPulse;
